export default "data:text/plain;base64,Z29vZ2xlLXNpdGUtdmVyaWZpY2F0aW9uOiBnb29nbGVhYTdhOGIyZDZhMTc2ZmQyLmh0bWw="